export const formStyles = {
  error: error => classNames('input', {
    'is-danger': error
  }),
  input: error => classNames('columns mb-3 is-mobile', {
    'mb-5': error
  }),
  validation: 'has-text-danger has-text-left has-text-weight-semibold is-size-7',
};
